import { render } from "./ReferMCI.vue?vue&type=template&id=0e5fd5fd&scoped=true"
import script from "./ReferMCI.vue?vue&type=script&lang=js"
export * from "./ReferMCI.vue?vue&type=script&lang=js"

import "./ReferMCI.vue?vue&type=style&index=0&id=0e5fd5fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5fd5fd"]])

export default __exports__